module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/welcome_to_tfl.b625ad91b828b039268bd5718050181e.svg";